import { useAtom } from "jotai";
import { useCallback } from "react";

import {
	$errorRelatedFile,
	$isErrorRelatedFile,
	$isLoadingRelatedFile,
	$readRelatedFile,
} from "../../internal/document/read-file-contents.atom";
import { store } from "../../internal/store";

export const useRelatedFileContents = () => {
	const [isLoading, setIsLoading] = useAtom($isLoadingRelatedFile);
	const [isError, setIsError] = useAtom($isErrorRelatedFile);
	const [error, setError] = useAtom($errorRelatedFile);

	const callback = useCallback(
		async ({
			workspaceName,
			documentId,
			pageId,
			filename,
			src,
			token,
		}: {
			workspaceName: string;
			documentId: string;
			pageId: string;
			/** The filename in the related/ folder (for Moment-created images) */
			filename?: string;
			/** A path relative to the document root (for imported images with src attribute) */
			src?: string;
			token?: string;
		}) => {
			try {
				setIsLoading(true);
				// Use store.get() instead of useAtomValue to read atoms outside of React render
				const relatedFile = await store.get(
					$readRelatedFile({ workspaceName, documentId, pageId, filename, src, token })
				);
				return relatedFile;
			} catch (error) {
				setIsError(true);
				const normalizedError = error instanceof Error ? error : new Error(String(error));
				setError(normalizedError);
				throw error;
			} finally {
				setIsLoading(false);
			}
		},
		[setIsLoading, setIsError, setError]
	);

	return {
		callback,
		isLoading,
		isError,
		error,
	};
};
